<ion-header class="m-grading-page-header">
  <ion-row class="ion-align-items-center ion-justify-content-between">
    <ion-col size="12" class="ion-no-padding">
      <monorepo-bctx-header
        [bctxHeader]="bctxHeader"
        (onBack)="handleExit()"
        [variableGroupFieldsInfo]="variableGroupFieldsInfo"
        [enableBack]="true"
      ></monorepo-bctx-header>
    </ion-col>
  </ion-row>
</ion-header>
<ion-content class="m-grading-page-content">
  <ion-row class="content-row">
    <ion-col size="8" class="size-tiles-block-col">
      <ion-row class="ion-justify-content-between ion-align-items-center heading-block">
        <ion-col size="3" class="ion-padding-start">
          {{ 'grading_page.sizeList' | translate }}
        </ion-col>
        <ion-col size="8">
          <ion-row class="ion-align-items-center" style="flex-direction: row-reverse">
            <div class="filter-icon" (click)="filterSizeItem()">
              <ion-img [src]="sizeFilterIcon"></ion-img>
            </div>
            <div class="undo-icon" (click)="handleUndo()">
              <ion-img [src]="undoIcon"></ion-img>
            </div>
            <div class="sync-icon" (click)="handleSync()">
              <ion-img [src]="syncIcon"></ion-img>
            </div>
            <div class="ion-padding-end">
              <span>
                {{
                  actionType === 'FTT'
                    ? ('input_app_common.rft' | translate)
                    : actionType === 'REJECTED'
                    ? ('grading_page.rejected' | translate)
                    : actionType === 'DEFECTIVE'
                    ? ('grading_page.defective' | translate)
                    : ''
                }}
              </span>
              <span>{{ totalActuals }}</span>
            </div>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="size-tiles-block">
        <ng-container *ngFor="let item of sizeList; let i = index; trackBy: trackByFn">
          <ng-container *ngIf="visibleSizeList[i].status && !item.isInactive">
            <ion-col size-lg="3" size-md="4">
              <div
                class="size-tile ion-activatable ripple-parent rounded-rectangle"
                [ngClass]="{
                  'size-tile--disabled':
                    appIdentifier !== 'plan_qc_v2' &&
                    (appIdentifier !== 'line_in_v2' || isWipValidationEnabledLineIn) &&
                    (!bctxWipMap[bctxKey] || bctxWipMap[bctxKey].sizeToWipMap[item.name].wip_qty <= 0)
                }"
                (click)="notifyUpdateSizeListIndex(item.name)"
              >
                <div class="actual-count">
                  {{ 'grading_page.actuals' | translate }}: {{ item.client_work[this.actionType].actuals }}
                </div>
                <div>
                  <div class="size-name">{{ item.name }}</div>
                  <div
                    class="wip-count"
                    *ngIf="
                      appIdentifier !== 'plan_qc_v2' && (appIdentifier !== 'line_in_v2' || isWipValidationEnabledLineIn)
                    "
                  >
                    {{ 'grading_page.wip' | translate }}:
                    {{
                      bctxWipMap[bctxKey] && bctxWipMap[bctxKey].sizeToWipMap[item.name].wip_qty > 0
                        ? bctxWipMap[bctxKey].sizeToWipMap[item.name].wip_qty
                        : 0
                    }}
                  </div>
                </div>
                <ion-ripple-effect></ion-ripple-effect>
              </div>
            </ion-col>
          </ng-container>
        </ng-container>
      </ion-row>
    </ion-col>
    <ion-col size="4" class="number-pad-block-col">
      <div class="number-pad">
        <monorepo-bulk-count-pad
          [enableBulkChange]="enableBulkChange"
          [count]="count"
          (bulkCount)="handleBulkCount($event)"
          [bulkCountStream]="quantityOptions"
        ></monorepo-bulk-count-pad>
      </div>
    </ion-col>
  </ion-row>
</ion-content>
<ion-footer class="m-grading-page-footer">
  <ion-row>
    <ion-col size="4" class="go-back-button" (click)="handleExit()">
      <ion-img [src]="goBackIcon" class="ion-padding-end"></ion-img>{{ 'grading_page.goBack' | translate }}</ion-col
    >
    <ion-col
      size="8"
      class="proceed-button"
      [ngClass]="{ 'proceed-button--disabled': isProceedDisabled }"
      (click)="handleProceed()"
    >
      {{ 'grading_page.proceed' | translate }} <ion-img [src]="proceedIcon" class="ion-padding-start"></ion-img
    ></ion-col>
  </ion-row>
</ion-footer>
